<section class="faq col-sm-12 col-md-9">
  <h2 class="faq__title">{{ faq().title }}</h2>
  <div class="faq__description">{{ faq().description }}</div>
  <ul class="faq__list">
    @for (item of faq().faqItems; track item.question) {
      <li class="faq__list-item">
        <details
          class="faq__item"
          trackInteraction="click"
          interactionCategory="accordion"
          [interactionData]="{ subject: 'faq', name: item.question }"
        >
          <summary class="faq__item-question">
            <h3 class="faq__item-heading">
              {{ item.question }}
            </h3>
          </summary>
          <div class="faq__item-answer">
            <div *wlGenericRichText="{ value: item.answer }"></div>

            @if (feedbackSettings()) {
              <wl-faq-feedback
                [question]="item.question"
                [feedbackSettings]="feedbackSettings()!"
              />
            }
          </div>
        </details>
      </li>
    }
  </ul>
</section>
